(() => {
  const SELECTORS = ['[class*="gorgias-chat-key-"]'];

  const hideIn = (root) => {
    SELECTORS.forEach((selector) => {
      if (root.matches && root.matches(selector)) {
        root.style.setProperty('display', 'none', 'important');
      }
      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach((el) => {
          el.style.setProperty('display', 'none', 'important');
        });
      }
    });
  };

  // Klaviyo locks scroll by adding the `klaviyo-prevent-body-scrolling` class to
  // <body> after we have already hidden its popup, leaving the page frozen with
  // nothing to dismiss. Remove ONLY that class the moment it appears — nothing
  // else on <body> or <html> is touched.
  const LOCK_CLASS = 'klaviyo-prevent-body-scrolling';

  const unlockScroll = () => {
    if (document.body && document.body.classList.contains(LOCK_CLASS)) {
      document.body.classList.remove(LOCK_CLASS);
    }
  };

  hideIn(document);
  unlockScroll();

  const nodeObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hideIn(node);
      });
    }
  });

  nodeObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.body) {
    const lockObserver = new MutationObserver(unlockScroll);
    lockObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
